module.exports = __webpack_public_path__ + "media/9-Basirat_Testimonial.674be2d1.mp3";